import { Component, Vue } from 'vue-facing-decorator';;
import { ElMessage, ElMessageBox } from 'element-plus';
import { Suitcase, Finished } from '@element-plus/icons-vue';
import Header from '@/components/Header/Header.vue';
import Navigation from '@/components/Navigation/Navigation.vue';
import NavigationIndex from "@/models/EnumNavigationIndex";
import Breadcrumbs from '@/components/Breadcrumbs/Breadcrumbs.vue';
import AuthService from '@/services/AuthService';
import ApiService from '@/services/ApiService';

@Component(
{
    components:
    {
        Header,
        Breadcrumbs,
        Navigation,
		Suitcase,
		Finished
    },
    enums:
    {
        NavigationIndex
    }
})

export default class RoleEdit extends Vue
{
    private roleId: string = '';
    private roleName: string = '';
    private activeName: string = "1";
    private loading: boolean = true;
    private formRoleValid: boolean = false;
    private formPasswordValid: boolean = false;
    private hasPermission: boolean[] = [] as boolean[];
    private roleModel: RoleModel | undefined = {} as RoleModel;
    private permissionModelList: PermissionModel[] | undefined = [] as PermissionModel[];
    private permissions : boolean[] = [] as boolean[];
    private sections : string[] = [] as string[];
    private windowWidth : number = window.innerWidth;
    private windowHeight : number = window.innerHeight;
    private lastTitle : string = ""; 
    private rules =
    {
        name:
        [
            {
                required: true,
                message: "Bitte geben Sie einen Name für die Rolle ein.",
                trigger: "blur"
            }
        ],
        description:
        [
            {
                required: true,
                message: "Bitte geben Sie eine Beschreibung für die Rolle ein.",
                trigger: "blur"
            }
        ]
    };

    public async mounted()
    {
        // get permissions
        await AuthService.getPermissions();
        this.hasPermission['ROLE_SELECT'] = AuthService.hasPermission("ROLE_SELECT");
        this.hasPermission['ROLE_INSERT'] = AuthService.hasPermission("ROLE_INSERT");
        this.hasPermission['ROLE_UPDATE'] = AuthService.hasPermission("ROLE_UPDATE");
        this.hasPermission['ROLE_DELETE'] = AuthService.hasPermission("ROLE_DELETE");

        // get role id from get request
        this.roleId = this.$route.params.roleid as string;

        // load role from db
        this.roleModel = await ApiService.getRole(this.roleId);
        
        this.sections['USER'] = 'Benutzer';
        this.sections['ROLE'] = 'Rollen';
        this.sections['CUST'] = 'Mandanten';
        this.sections['CATG'] = 'Kategorien';
        this.sections['TARG'] = 'Zielgruppen';
        this.sections['REFN'] = 'Referenzen';
        this.sections['QSTN'] = 'Fragenkatalog';
        this.sections['TEST'] = 'Prüfungen';
        this.sections['TKLS'] = 'Ticketlisten';
        this.sections['DASH'] = 'Dashboard';
        this.sections['SOUR'] = 'Quellen';
        this.sections['CLNT'] = 'Ämter';

        if (!this.roleModel)
        {
            this.$router.push('/role');
            return;
        }
        else
        {
            // get role name for breadcrumbs
            this.roleName = `${this.roleModel.name}`;

            // check form validity
            this.formRoleValid = this.validateRoleForm();

            // load role permissions
            this.loadRolePermissions();

            // load all permissions
            this.permissionModelList = await ApiService.getAllPermission();
        }

        window.addEventListener('resize', this.onWindowResize);

        this.loading = false;
    }

    private beforeUnmount()
    {
        window.removeEventListener('resize', this.onWindowResize);
    }

	private onWindowResize(e : any)
    {
        this.windowWidth = window.innerWidth;
        this.windowHeight = window.innerHeight;
    }

    private async loadRolePermissions()
    {
        if (this.roleModel)
        {
            // load role permissions
            this.roleModel.permissions = await ApiService.getPermissionsForRole(this.roleModel.roleid.toString());

            if (this.roleModel.permissions && this.roleModel.permissions.length > 0)
            {
                for (const p of this.roleModel.permissions)
                {
                    this.permissions[p.permissionid] = true;
                }
            }
        }
    }

    private async saveRole(role: RoleModel)
    {
        let ok: any = await ApiService.updateRole(role);

        if (ok)
        {
            this.roleName = `${role.name}`;
            ElMessage({message: "Änderungen wurden übernommen.", type: 'success'});
        }
        else
        {
            // or show error message
            ElMessage({message: "Änderungen konnten nicht gespeichert werden.", type: 'error'});
        }
    }

    private validateRoleForm() : boolean
    {
        if (!this.roleModel || !this.roleModel.name || this.roleModel.name.length <= 0) return false;
        if (!this.roleModel.description || this.roleModel.description.length <= 0) return false;

        return true;
    }

    private async changePermission(roleid : string, permissionid : number, permitted : boolean)
    {
        await ApiService.setRolePermission(Number(roleid), permissionid, permitted);
        await this.loadRolePermissions();
    }

    private onInput()
    {
        this.formRoleValid = this.validateRoleForm();
    }

    private onPermissionChange(permission: PermissionModel)
    {
        this.changePermission(this.roleId, permission.permissionid, this.permissions[permission.permissionid]);
    }

    private onRoleSaveClick()
    {
        if (this.roleModel)
        {
            this.saveRole(this.roleModel);
        }
    }
}
